import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import {
  Header,
  CenteredModal,
  InputCol,
  SelectCol,
  Buttons,
} from "components/common/modals";
import ConfirmModal from "components/common/modals/ConfirmModal";
import { brokerList } from "../../utils/constants";
import axios from "axiosConfig";
// Mock data for select inputs
// test frontend frontend
const defaultBroker = brokerList[0];
// console.log("Default Broker", defaultBroker);
const filteredBrokerOptions = brokerList.filter((broker) => broker !== defaultBroker);
// console.log("Filtered Broker", filteredBrokerOptions);


function BrokerModal({
  show,
  setShow,
  isShowEditModal,
  brokerData,
  setBrokers,
}) {
  const {
    broker,
    account_nickname,
    client_id,
    client_api_key,
    client_api_secret,
    totp_secret,
    id,
    on_off,
  } = brokerData;
  const [isConfirmModal, setIsConfirmModal] = useState(false);
  const [inputs, setInputs] = useState({
    account_nickname: account_nickname || "",
    broker: broker || "",
    brokerage_password: "",
    confirmPassword: "",
    client_id: client_id || "",
    client_api_key: client_api_key || "",
    client_api_secret: client_api_secret || "",
    totp_secret: totp_secret || "",
  });

  const [errors, setErrors] = useState({
    account_nickname: "",
    broker: "",
    brokerage_password: "",
    confirmPassword: "",
    client_id: "",
    client_api_key: "",
    client_api_secret: "",
    totp_secret: "",
  });
  const [isHideFields, setIsHideFields] = useState(false);
  // Data to be passed to the request payload
  const [postData, setPostData] = useState([]);
  // Check for changes on 'broker' state
  useEffect(() => {
    if (inputs.broker === defaultBroker) {
      setIsHideFields(true);
      setInputs(prev => ({
        ...prev,
        client_api_key: "",
        client_api_secret: "",
        totp_secret: "",
      }));
    } else setIsHideFields(false);
  }, [inputs.broker]);

  // Form submit
  const onSubmit = async event => {
    event.preventDefault();

    // Validate all inputs
    let postData = { on_off };
    let isError = false;
    for (const [key, value] of Object.entries(inputs)) {
      const errorMsg = validate(key, value);
      setErrors(prev => ({ ...prev, [key]: errorMsg }));
      console.log(errorMsg);

      if (errorMsg?.length > 0) isError = true;
      if (value.length !== 0 && value !== brokerData[key])
        postData = { ...postData, [key]: value };
    }

    // Check for errors

    if (isError || !postData) return;
    try {
      if (isShowEditModal) {
        // Remove confirm password
        delete postData.confirmPassword;
        setPostData(postData);
        setIsConfirmModal(true);
      } else {
        postData = { ...inputs };
        delete postData.confirmPassword;
        const { data } = await axios.post("api/brokersetting/", {
          ...postData,
        });
        setBrokers(prev => [...prev, data]);
        setShow(false);
      }
    } catch (error) {
      console.log("Brokersettings error: ", error);
    }
  };
  // Confirm update data
  const handleConfirmUpdate = async () => {
    try {
      const { data } = await axios.patch(`api/brokersetting/${id}/`, {
        ...postData,
      });
      setBrokers(prev => {
        const newBrokers = [...prev];
        const index = newBrokers.indexOf(brokerData);

        newBrokers.splice(index, 1, data);
        return newBrokers;
      });
      setShow(false);
      setIsConfirmModal(false);
    } catch (error) {
      console.log("Brokersettings error: ", error);
    }
  };

  // Handle input change

  const handleChange = e => {
    const { name, value } = e.target;

    // Use a callback to update each input change immediately
    setInputs(curInputs => ({ ...curInputs, [name]: value }));
    validateInput(e);
  };

  // Validate single input

  const validateInput = e => {
    let { name, value } = e.target;
    const errorMsg = validate(name, value);
    setErrors(prev => ({ ...prev, [name]: errorMsg }));
  };

  // Validate func

  const validate = (name, value) => {
    let errorMsg;
    if (isShowEditModal) {
      switch (name) {
        case "brokerage_password":
          if (inputs.confirmPassword && value !== inputs.confirmPassword) {
            errorMsg = "Password and Confirm Password does not match.";
          }
          break;

        case "confirmPassword":
          if (
            inputs.brokerage_password &&
            value !== inputs.brokerage_password
          ) {
            errorMsg = "Password and Confirm Password does not match.";
          } else {
            errorMsg = inputs.confirmPassword ? "" : errors.confirmPassword;
          }
          break;

        default:
          break;
      }
    } else {
      switch (name) {
        case "brokerage_password":
          if (!value) {
            errorMsg = "Please enter Confirm Password.";
          }
          break;

        case "confirmPassword":
          if (!value) {
            errorMsg = "Please enter Password.";
          } else if (
            inputs.brokerage_password &&
            value !== inputs.brokerage_password
          ) {
            errorMsg = "Password and Confirm Password does not match.";
          } else {
            errorMsg = inputs.confirmPassword ? "" : errors.confirmPassword;
          }
          break;
        case "account_nickname":
          if (!value) {
            errorMsg = "Please enter nickname for account.";
          }
          break;
        case "client_id":
          if (!value) {
            errorMsg = "Please enter Client ID.";
          }
          break;
        case "client_api_key":
          if (!value && !isHideFields) {
            errorMsg = "Please enter API key.";
          }
          break;
        case "client_api_secret":
          if (!value && !isHideFields) {
            errorMsg = "Please enter API Secret.";
          }
          break;
        case "totp_secret":
          if (!value && !isHideFields) {
            errorMsg = "Please enter OTP Key.";
          }
          break;
        default:
          break;
      }
    }

    return errorMsg;
  };

  const content = (
    <Container>
      <Row>
        {/* Header */}
        {/* Different setup for Add (Has Header) and Edit (Has no header) broker */}
        {!isShowEditModal && (
          <Header
            title={"Broker Account"}
            text={
              // "Dollar Cost Averaging: It is an investment strategy that involves investing a fixed amount of money at regular intervals over a period of time, regardless of the market conditions."
                "Broker Account is where your investments are made and held. " +
                "You can add multiple broker accounts here."
            }
          />
        )}

        {/* Form Inputs */}
        <Col sm={12} lg={8} className="mt-4 mt-lg-5 mx-auto">
          <Form noValidate onSubmit={onSubmit}>
            <Row>
              <Col sm={12} className="mb-4 text-center text-lg-start">
                {/* Different setup for Add and Edit broker */}
                <h3>{isShowEditModal ? "Edit" : "Add"} your Broker</h3>
              </Col>
              {/* Main inputs */}
              <InputCol
                label="Account Nickname"
                name={"account_nickname"}
                type="text"
                value={inputs.account_nickname}
                errorMsg={errors.account_nickname}
                handleChange={handleChange}
                validateInput={validateInput}
                placeholder="Nickname for your account"
                isValidate={true}
                hint={"An easy to identify account name for your broker account."}
              />
              <SelectCol
                label="Select Broker"
                name={"broker"}
                value={inputs.broker}
                handleChange={handleChange}
                defaultVal={defaultBroker}
                // placeholder="Select Broker"
                options={filteredBrokerOptions}
                hint="Select your broker from the list."
              />
              {/* Additional Inputs */}
              <Col sm={12} className="mt-4 mb-5 d-flex justify-content-center">
                <Container>
                  <Row
                    style={{
                      padding: "20px",
                      border: "1px solid #4C4B56",
                      borderRadius: "8px",
                    }}
                  >
                    <Col sm={12} className="px-0">
                      {/*<h5>Details</h5>*/}
                    </Col>
                    <InputCol
                      label="Brokerage Password"
                      colClass="px-0 pe-lg-2"
                      name={"brokerage_password"}
                      type="password"
                      value={inputs.brokerage_password}
                      errorMsg={errors.brokerage_password}
                      handleChange={handleChange}
                      validateInput={validateInput}
                      isValidate={true}
                      placeholder="Enter password"
                      hint="Your broker account password, our systems will use it to login and invest for you."
                    />

                    <InputCol
                      label="Confirm Password"
                      colClass="px-0 ps-lg-2"
                      name={"confirmPassword"}
                      type="password"
                      value={inputs.confirmPassword}
                      errorMsg={errors.confirmPassword}
                      handleChange={handleChange}
                      validateInput={validateInput}
                      isValidate={true}
                      placeholder="Confirm password"
                      hint="Confirm the broker password."
                    />

                    <InputCol
                      label="Client ID"
                      name={"client_id"}
                      type="text"
                      value={inputs.client_id}
                      errorMsg={errors.client_id}
                      validateInput={validateInput}
                      handleChange={handleChange}
                      colClass="px-0 pe-lg-2"
                      placeholder="Client ID"
                      hint="Your Client ID at the broker."
                    />
                    {!isHideFields && (
                      <>
                        <InputCol
                          label="API Key"
                          colClass="px-0 ps-lg-2"
                          name={"client_api_key"}
                          type="text"
                          value={inputs.client_api_key}
                          errorMsg={errors.client_api_key}
                          validateInput={validateInput}
                          handleChange={handleChange}
                          placeholder="0"
                          hint="percentage of a purchase 
              price that a buyer pays as a down payment."
                        />

                        <InputCol
                          label="API Secret"
                          colClass="px-0 pe-lg-2"
                          name={"client_api_secret"}
                          type="password"
                          value={inputs.client_api_secret}
                          errorMsg={errors.client_api_secret}
                          validateInput={validateInput}
                          handleChange={handleChange}
                          placeholder="0"
                          hint="percentage of a purchase 
              price that a buyer pays as a down payment."
                        />
                        <InputCol
                          label="OTP Key"
                          colClass="px-0 ps-lg-2"
                          name={"totp_secret"}
                          type="password"
                          value={inputs.totp_secret}
                          errorMsg={errors.totp_secret}
                          validateInput={validateInput}
                          handleChange={handleChange}
                          placeholder="0"
                          hint="percentage of a purchase 
              price that a buyer pays as a down payment."
                        />
                      </>
                    )}
                  </Row>
                </Container>
              </Col>
              <Buttons
                setShow={setShow}
                isShowEditModal={isShowEditModal}
                addBtnText={"Broker"}
              />
            </Row>
          </Form>
        </Col>
      </Row>
      {/* Update confirmation modal */}
      <ConfirmModal
        show={isConfirmModal}
        handleClick={handleConfirmUpdate}
        setShow={setIsConfirmModal}
        header="Are you sure you want to Update this Broker?"
      />
    </Container>
  );

  return (
    <CenteredModal
      bodyContent={content}
      show={show}
      setShow={setShow}
      //  Different setup for Add and Edit broker
      size={isShowEditModal ? "lg" : "xl"}
    />
  );
}

export default BrokerModal;
